import React, { useMemo, useState } from 'react'
import { useDebounce } from '@node-space/hooks'
import { Avatar, ComboboxItem } from '@node-space/ui-components'
import { useEarnWalletsQuery } from './api/useEarnWalletsQuery'

interface UseEarnWalletsOptionsProps {
  selectedCurrency: string
}

export const useEarnWalletsOptions = ({ selectedCurrency }: UseEarnWalletsOptionsProps) => {
  const [searchEarnWallets, setSearchEarnWallets] = useState('')
  const debouncedSearchEarnWallets = useDebounce(searchEarnWallets, 500)

  const {
    data: earnWalletsData,
    isLoading: isLoadingEarnWallets,
    isError: isEarnWalletsError,
  } = useEarnWalletsQuery({
    currencyCode: selectedCurrency,
    searchTerm: debouncedSearchEarnWallets,
    includeCustomerWallets: false,
  })

  const earnWallets = earnWalletsData?.content || []

  const earnWalletsOptions = useMemo<ComboboxItem[]>(() => {
    if (!earnWallets || !selectedCurrency) return []

    return earnWallets.map(wallet => ({
      value: wallet.id,
      leftText: wallet.name,
      LeftElement: <Avatar name={wallet.balance.currencyCode} size="small" />,
      rightText: `${wallet.balance.value} ${wallet.balance.currencyCode}`,
    }))
  }, [earnWallets, selectedCurrency])

  const onSearchChange = (search: string) => {
    setSearchEarnWallets(search)
  }

  return {
    earnWallets,
    earnWalletsOptions,
    onSearchChange,
    isLoading: isLoadingEarnWallets,
    isError: isEarnWalletsError,
  }
}
